<template>
  <div>
    <p class="exclusive-add-ons-title">Exclusive Add-ons</p>
    <div v-if="priceChangeAddOns.length > 0" class="flex flex-col gap-4 mt-4">
      <AddOnCard 
        v-for="addOn in priceChangeAddOns" 
        :key="addOn.id" 
        :add-on-name="addOn.testName"
        :sample-types="getSampleTypes(addOn.sampleTypeSets)"
        :price="addOn.addOnPrice"
        :original-price="addOn.originalPrice"
        :has-discount="true"
        :info-icon="addOn.infoIcon"
        @add-click="handleAddClick(addOn)"
      />
    </div>
    <div v-if="noPriceChangeAddOns.length > 0" class="flex flex-col gap-4 mt-6">
      <AddOnCard 
        v-for="addOn in noPriceChangeAddOns" 
        :key="addOn.id" 
        :add-on-name="addOn.testName"
        :price="addOn.addOnPrice"
        :original-price="addOn.originalPrice"
        :has-discount="false"
        :info-icon="addOn.infoIcon"
        @add-click="handleAddClick(addOn)"
      />
    </div>
  </div>

</template>

<script>
  import AddOnCard from './AddOnCard.vue';
  export default {
    components: {
      AddOnCard
    },
    props: {
      addOns: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      priceChangeAddOns() {
        return this.addOns.filter(addOn => addOn.addOnPrice !== addOn.originalPrice);
      },
      noPriceChangeAddOns() {
        return this.addOns.filter(addOn => addOn.addOnPrice === addOn.originalPrice);
      }
    },
    methods: {
      handleAddClick(addOn) {
        this.$store.dispatch("orderTest/addSelectedTest", { id: addOn.id });
      },
      getSampleTypes(sampleTypeSets) {
        if (!sampleTypeSets) {
          return [];
        }
        return [...sampleTypeSets.blood, ...sampleTypeSets.nonBlood, ...sampleTypeSets.dryIce];
      }
    }
  }
</script>

<style scoped>
.exclusive-add-ons-title {
  color: #4A4A4A;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.458px;
}
</style>